import React, { useState } from 'react';

import NewsContext from './context/news-context';
import AppRouter from './router/AppRouter';
import './GlobalStyles.css';

const App = () => {
    const [news, setNews] = useState({});
    const [user, setUser] = useState({});
    return (
        <NewsContext.Provider value={{news, setNews, user, setUser}}>
            <AppRouter />
        </NewsContext.Provider>
    );
};

export default App;